import { render, staticRenderFns } from "./VersionedContentLink.vue?vue&type=template&id=44f12370&scoped=true&"
import script from "./VersionedContentLink.vue?vue&type=script&lang=js&"
export * from "./VersionedContentLink.vue?vue&type=script&lang=js&"
import style0 from "./VersionedContentLink.vue?vue&type=style&index=0&id=44f12370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../nonspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f12370",
  null
  
)

component.options.__file = "VersionedContentLink.vue"
export default component.exports